import { useEffect, useState } from 'react';
import './timer.css';

function Timer({ duration, onDone}) {

    const [seconds,setSeconds] = useState(duration);
    const [timer, setTimer] = useState();
  

    useEffect(() => {
        if(seconds <= 0){
            onDone();
          clearInterval(timer);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [seconds]);
    
    useEffect(() => {
        const timer1 =  setInterval(() => {
           setSeconds(s => s-1);
         }, 1000);
     
         setTimer(timer1);
       }, []);
     
  return (
    <div  className="timer">
        {seconds}s
    </div>
  );
}

export default Timer;
